import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import ComfirmationBox from '../shared/ConfirmationBox';
import { ButtonContainer, ModalBodyContainer, customStyles } from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import request from '../../utils/request';

const SessionTimeout = ({ children }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    SessionTimeout: { alertTitle, bodyMessage, buttonText }
  } = localizedStrings;
  const [isOpen, setOpen] = useState(false);

  const checkForToken = () => {
    request.get('/users/checkToken').then(response => {
      if (response && response.status === 200) {
        if (response.data && response.data.isExpired) {
          if (localStorage.getItem('accessToken') !== null) {
            setOpen(true);
          }
        }
      }
    });
  };

  const checkForTokenInterceptors = () => {
    if (localStorage.getItem('isExpired') === true) {
      if (localStorage.getItem('accessToken') !== null) {
        setOpen(true);
      }
    }
  };

  const unlockOrders = () => {
    const pathName = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    const stepNumber = urlParams.get('step') || 1;

    if (
      !(
        pathName.includes('Order_Details') ||
        (pathName.includes('Business_Connect_Quote_Tool') && +stepNumber === 2)
      )
    )
      request.get('/orders/unlock');
  };

  const handleLogin = () => {
    setOpen(false);
    localStorage.clear();
    window.location.pathname = '/';
  };

  useEffect(() => {
    let sessionInterval;
    if (localStorage.getItem('accessToken') !== null) {
      sessionInterval = setInterval(() => {
        checkForToken();
        checkForTokenInterceptors();
        unlockOrders();
      }, 5000);
    } else {
      clearInterval(sessionInterval);
    }
  }, []);

  return (
    <>
      {children}
      <ComfirmationBox
        hideCloseButton
        open={isOpen}
        setOpen={setOpen}
        customStyles={customStyles}
        header={alertTitle}
      >
        <ModalBodyContainer>
          <text>{bodyMessage}</text>
          <ButtonContainer>
            <Button onClick={handleLogin}>{buttonText}</Button>
          </ButtonContainer>
        </ModalBodyContainer>
      </ComfirmationBox>
    </>
  );
};

SessionTimeout.propTypes = {
  children: PropTypes.node.isRequired
};

export default SessionTimeout;
